/**
 * Plain text for a failed SpecTree Toolbox bridge call (epic PI-SPEC-SW-E290,
 * feature PI-SPEC-SW-1478, UX-PM-07).
 *
 * Electron rejects a failed `ipcRenderer.invoke` with
 * "Error invoking remote method 'grooming:resumeQueue': Error: Claude Code is
 * not signed in". The prefix names an internal channel and means nothing to
 * the person reading it, so it is removed and only the app's own sentence is
 * shown.
 */

/** Electron's prefix on a rejected bridge call, with the optional "Error: " after it. */
export const BRIDGE_ERROR_PREFIX = /^Error invoking remote method '[^']+': (?:[A-Za-z]*Error: )?/;

/**
 * The message of a caught bridge error without Electron's prefix, or
 * `fallback` when there is no message left. Accepts an `Error`, a string,
 * or anything else (which reads as the fallback).
 */
export function plainBridgeError(error: unknown, fallback: string): string {
  const raw = error instanceof Error ? error.message : typeof error === "string" ? error : "";
  const plain = raw.replace(BRIDGE_ERROR_PREFIX, "").trim();
  return plain.length > 0 ? plain : fallback;
}
